import { createRootRoute, Outlet } from "@tanstack/react-router";
import * as Sentry from "@sentry/capacitor";
import { ErrorBoundaryFallback } from "@/components/ErrorBoundaryFallback";
import { useEffect } from "react";

// Custom error component dla TanStack Router
function RouterErrorComponent({ error, reset }: { error: Error; reset: () => void }): JSX.Element {
	// Wysyłamy błąd do Sentry W EFFECT, nie podczas renderowania
	useEffect(() => {
		const eventId = Sentry.captureException(error, {
			level: 'error',
			contexts: {
				router: {
					location: window.location.href,
				},
			},
		});
		
		console.log('[Sentry] Router error captured in useEffect:', eventId);
		
		// Opcjonalnie: wymuś flush
		void Sentry.flush(2000);
	}, [error]);
	
	// Używamy tego samego UI co ErrorBoundaryFallback
	return (
		<ErrorBoundaryFallback
			error={error}
			componentStack={null}
			eventId={null} // eventId będzie dostępny dopiero w useEffect
			resetError={reset}
		/>
	);
}

export const Route = createRootRoute({
	component: () => (
		<>
			<Outlet />
		</>
	),
	errorComponent: RouterErrorComponent,
});
